// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slideshow_slide__1A1Iy","slidesContainer":"Slideshow_slidesContainer__1ja-U"};